module.exports = __webpack_public_path__ + "static/advice5-fdd5e37fa16a12d559c8dcc673d85880.png";